import {
  SET_DICOM_SELECTION_DATA,
  REMOVE_DICOM_SELECTION_DATA,
  CLEAR_DICOM_SELECTION_DATA
} from '.';
import {
  SetSelectedDicomPayloadParams,
  SetSelectedDicomAction,
  RemoveSelectedDicomAction,
  ClearSelectedDicomAction,
  ClearSelectedDicomPayloadParams
} from '../mappers/SelectedDicomTypesMapper';

export const setSelectedDicom = (
  dispatch: (action: SetSelectedDicomAction) => void,
  params: SetSelectedDicomPayloadParams
): void => {
  dispatch({
    type: SET_DICOM_SELECTION_DATA,
    payload: params
  });
};

export const removeSelectedDicom = (
  dispatch: (action: RemoveSelectedDicomAction) => void,
  params: SetSelectedDicomPayloadParams
): void => {
  dispatch({
    type: REMOVE_DICOM_SELECTION_DATA,
    payload: params
  });
};

export const clearSelectedDicom = (
  dispatch: (action: ClearSelectedDicomAction) => void,
  params: ClearSelectedDicomPayloadParams
): void => {
  dispatch({
    type: CLEAR_DICOM_SELECTION_DATA,
    payload: params
  });
};
